import { RowColumn } from '../../Containers';
import { Skeleton } from '../../UI';

import { Select, SelectProps, SelectPropsWithNoOptions } from '../Select';
import { Label } from '../Label';

import { cn } from 'styles';

import { WithLabelCommonProps } from './types';
import { AnyObject } from 'types';

export type LabeledSelectProps<E extends AnyObject> = WithLabelCommonProps & SelectProps<E>;

export type LabeledSelectWithNoOptionsProps<E extends AnyObject> = WithLabelCommonProps &
  SelectPropsWithNoOptions<E>;

export function LabeledSelect<Entity extends AnyObject>({
  containerClassName,
  fullWidth,
  gap = '2',
  orientation = 'vertical',

  label,
  labelClassName,
  labelIcon: LabelIcon,

  loading,
  error,

  ...selectProps
}: LabeledSelectProps<Entity>) {
  const hasError = !!error;

  return (
    <RowColumn
      orientation={orientation}
      fullWidth={fullWidth}
      className={containerClassName}
      gap={gap}
    >
      {label && (
        <Label className={labelClassName} htmlFor={selectProps.id} icon={LabelIcon}>
          {label}
        </Label>
      )}

      {loading ? (
        <Skeleton height={36} />
      ) : (
        <Select
          className={cn(selectProps.className, hasError && 'border-destructive')}
          mobileTitle={label}
          {...selectProps}
        />
      )}

      {hasError && typeof error == 'string' && (
        <span className="-mt-1 pl-0.5 text-sm text-destructive">{error}</span>
      )}
    </RowColumn>
  );
}
